<div *ngIf="DynamicFields" >

  <div class="modal-header" *ngIf="IsModal" [ngClass]="DynamicFields?.modalTitleClass ?? ''">
    <h5 class="modal-title" id="editUserLabel">{{ DynamicFields.Label }}</h5>

    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div [ngClass]="{'': IsModal, 'card': !IsModal }" *ngIf="DynamicFields?.campi || (Item?.type == 'E' && Item?.tipo == 'LA' && FromLista)">
    <div [ngClass]="{'modal-body': IsModal, 'card-body': !IsModal }">
      <app-field-viewer [(DropdownSources)]="DropdownSources" [(Oggetto)]="Item" [Campi]="DynamicFields.campi" (CustomButton)="customButton(Item, $event)" (OnChange)="ChangeHandler($event)"></app-field-viewer>
      <div *ngIf="Item?.type == 'E' && Item?.tipo == 'LA' && FromLista">
        <div class="d-md-flex align-items-center p-3 ng-star-inserted" style="background-color: #87858525;">
          <span class="d-flex align-items-center p-2 ng-star-inserted">
            <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14">Attività</h5>
          </span><!---->
        </div>
        <app-dynamic-col-table (Refresh)="Refresh()" [(columns)]="Item.figli" [(rows)]="Item.clientiObject" [hasSave]="true"
          (onSaveClick)="UpdateAttivitas()"></app-dynamic-col-table>
      </div>
    </div>
  </div>

  <div [ngClass]="{'': IsModal, 'card': !IsModal }" *ngIf="DynamicFields?.sezioni && !ResetFields">
    <div [ngClass]="{'modal-body': IsModal, 'card-body': !IsModal }">
      <div
      *ngIf="isFiglioDaConfermare"
      class="alert alert-info d-flex flex-column flex-md-row
             justify-content-between align-items-md-center mb-3"
    >
      <div class="mr-md-3">
        <strong>Intervento da confermare</strong>
    
        <div *ngIf="!isOperatoreResponsabile">
          Conferma l’intervento per continuare con la compilazione.
        </div>
        
        <div *ngIf="isOperatoreResponsabile">
          Conferma per registrare l'avvio dell'intervento
        </div>
      </div>
    
      <button
        type="button"
        class="btn btn-info mt-2 mt-md-0"
        [disabled]="saving"
        (click)="confermaEContinua()"
      >
        <ng-container *ngIf="!saving">
          <i class="fas fa-check mr-1"></i>
          Conferma e Inizia Intervento
        </ng-container>
    
        <ng-container *ngIf="saving">
          <i class="fas fa-spinner fa-spin mr-1"></i>
        
          <span *ngIf="!isOperatoreResponsabile">
            Salvataggio...
          </span>
        
          <span *ngIf="isOperatoreResponsabile">
            Avvio...
          </span>
        </ng-container>
      </button>
    </div>
    <div
      *ngIf="puoIniziareIntervento"
      class="alert alert-warning d-flex flex-column flex-md-row
             justify-content-between align-items-md-center mb-3"
    >
      <div class="mr-md-3">
        <strong>Intervento non ancora iniziato</strong>

        <div>
          Premi il pulsante per registrare la data e l’ora
          di inizio dell’intervento.
        </div>
      </div>

      <button
        type="button"
        class="btn btn-warning mt-2 mt-md-0"
        [disabled]="saving"
        (click)="iniziaIntervento()"
      >
        <ng-container *ngIf="!saving">
          <i class="fas fa-play mr-1"></i>
          Inizia intervento
        </ng-container>

        <ng-container *ngIf="saving">
          <i class="fas fa-spinner fa-spin mr-1"></i>
          Avvio...
        </ng-container>
      </button>
    </div>
      <app-sector-viewer
  *ngIf="isFiglioDaConfermare"
  [(DropdownSources)]="DropdownSources"
  (OnFilter)="FilterHandler($event)"
  (CustomButton)="customButton(Item, $event)"
  (OnChange)="ChangeHandler($event)"
  [Campi]="SezioniConferma"
  [(Oggetto)]="Item">
</app-sector-viewer>
      <app-sector-viewer *ngIf="!isFiglioDaConfermare" [(DropdownSources)]="DropdownSources" (OnFilter)="FilterHandler($event)"
      (CustomButton)="customButton(Item, $event)"
                         (OnChange)="ChangeHandler($event)" [(Campi)]="DynamicFields.sezioni"
                         [(Oggetto)]="Item"></app-sector-viewer>

    </div>
  </div>
  <div class="d-md-flex align-items-center justify-content-end m-b-10 m-r-10">
    <ng-container *ngIf="!HideButtons">
      <ng-container *ngFor="let button of DynamicFields['Azioni']">
        <button
          type="button"
          [ngClass]="button['class']"
          [ngbTooltip]="button.placeholder ?? ''"
          *ngIf="
            (!isFiglioDaConfermare || button.nome === 'Delega') &&
            (!button.hideOnSubtab || !FromLista) &&
            (button.nome !== 'Elimina' || !HideDelete) &&
            permission.HasCapacity(button['capacita']) &&
            campoUtility.ButtonShow(button, Item)
          "
          (click)="customButton(Item, button)"
        >
          <i
            *ngIf="button['icon']"
            [ngClass]="button['icon']"
            class="font-14 mr-1 text-white">
          </i>
    
          <span [ngClass]="button['labelClass']">
            {{ button['nome'] | translate }}
          </span>
        </button>
      </ng-container>
    </ng-container>
   <!-- <ng-container *ngIf="!HideButtons && !isFiglioDaConfermare">
      <ng-container *ngFor="let button of DynamicFields['Azioni']">
        <button type="submit" type="button" [ngClass]="button['class']" [ngbTooltip]="button.placeholder ?? ''"
                *ngIf=" (!button.hideOnSubtab || !FromLista) && (button.nome != 'Elimina' || !HideDelete ) && permission.HasCapacity(button['capacita']) && campoUtility.ButtonShow(button,Item)"
                (click)='customButton(Item,button)'>
          <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1 text-white"></i>
          <span [ngClass]="button['labelClass']"> {{ button['nome'] | translate }} </span>
        </button>
      </ng-container>
    </ng-container>-->
    <button type="submit" *ngIf="!isFiglioDaConfermare && !puoIniziareIntervento && !hideSaveButton()" (click)="save(ExternalAdd)" style="margin: 0.75px;" class=" btn btn-success  waves-effect waves-light">
      <span class="mr-1 text-white "> Salva </span>
      <i class="far fa-save text-white"></i>
    </button>
    <button type="submit" *ngIf="!isFiglioDaConfermare && !puoIniziareIntervento && !hideSaveButton() && permission.IAmYourFather()" (click)="saveDryRun(ExternalAdd)" style="margin: 0.75px;"
      class=" btn btn-success  waves-effect waves-light">
      <span class="mr-1 text-white "> Dry Run </span>
      <i class="far fa-save text-white"></i>
    </button>
    <button type="submit" *ngIf="!isFiglioDaConfermare && !puoIniziareIntervento && !hideSaveButton() && !ExternalAdd" (click)="save(true)" style="margin: 0.75px;"
            class=" btn btn-success  waves-effect waves-light">
      <span class="mr-1 text-white "> Salva e chiudi </span>
      <i class="far fa-save text-white"></i>
    </button>
    <button type="submit" (click)="close()" style="margin: 0.75px;" class=" btn btn-danger  waves-effect waves-light">
      <span class="mr-1 text-white "> Chiudi </span>
      <i class="far fa-window-close text-white"></i>
    </button>
    <app-stampa [Stampe]="Stampe" *ngIf="!isFiglioDaConfermare && Stampe?.length > 0 && !HideButtons"></app-stampa>
  </div>
</div>
